import { api } from '../../lib/api';
import type { CrmOnboardingRun, CrmOnboardingStatus } from '../../types/crmOnboarding';

const q = (brand: string | null) => (brand ? `?brand=${encodeURIComponent(brand)}` : '');

export function getCrmOnboardingStatus(brand: string | null): Promise<{ status: CrmOnboardingStatus }> {
  return api(`/api/crm-onboarding/status${q(brand)}`);
}

export function listCrmOnboardingRuns(brand: string | null): Promise<{ runs: CrmOnboardingRun[] }> {
  return api(`/api/crm-onboarding/runs${q(brand)}`);
}

/**
 * Start a registry PREVIEW — a dry run that cannot write. The body carries the
 * brand and nothing else; the server refuses any other field.
 */
export function startRegistryPreview(brand: string | null): Promise<{ run: CrmOnboardingRun }> {
  return api('/api/crm-onboarding/registry/preview', {
    method: 'POST',
    body: JSON.stringify(brand ? { brand } : {}),
  });
}

/**
 * Confirm ONE preview. The server takes the group ids from the STORED preview
 * and pins them with --expect-groups; nothing about the groups is sent from here.
 */
export function confirmRegistryPreview(brand: string | null, previewId: string): Promise<{ run: CrmOnboardingRun }> {
  return api('/api/crm-onboarding/registry/confirm', {
    method: 'POST',
    body: JSON.stringify(brand ? { brand, previewId } : { previewId }),
  });
}

/**
 * Pull now. ⚠️⚠️ NO BODY — the server's flags are fixed and it refuses any key.
 * There is deliberately no way to ask for a window from here.
 */
export function startPullNow(brand: string | null): Promise<{ run: CrmOnboardingRun }> {
  return api(`/api/crm-onboarding/pull${q(brand)}`, { method: 'POST' });
}
